import React, { Component } from 'react';
import ReactGA from 'react-ga';

class MarkerComponent extends Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        // ReactGA.event({
        //     category: 'floorplan',
        //     action: 'click camera icon'
        // });
        this.props.setActiveImage(this.props.marker.file_name);
    }

    render() {
        const { marker, zoom, className } = this.props;

        let left,
            top;

        if (navigator.userAgent.toLowerCase().indexOf('opera') > -1
            || navigator.userAgent.toLowerCase().indexOf('firefox') > -1
            || navigator.userAgent.toLowerCase().indexOf('rv:11') > -1
            || navigator.userAgent.toLowerCase().indexOf('trident') > -1) {
                left = marker.coord_x;
                top = marker.coord_y;
        } else {
            left = marker.coord_x ;
            top = marker.coord_y ;
        }

        const style = {
            position:'absolute',
            left: left + 'px',
            top: top + 'px',
            // zoom: 1 / zoom,
            // transformOrigin: 'left top',
            transform: `scale(${1 / zoom}) translate(-5px, -7px)`,
            OTransform: `scale(${1 / zoom}) translate(-5px, -7px)`,
            // OTransformOrigin: 'left top',
            MozTransform: `scale(${1 / zoom}) translate(-5px, -7px)`,
            // MozTransformOrigin: 'left top'
        }
        return (
            <div
                className={className + ' marker'}
                style={style}
                onClick={this.onClick}
                data-image-name={marker.file_name}
                ref={marker => this.marker = marker}>
                <i className="fa fa-camera" aria-hidden="true"></i>
            </div>
        );
    }
}


export default MarkerComponent;
